export const mainNavigation = [
  {
    name: 'Home',
    url: '/home',
  },
  {
    name: 'Search',
    url: '/search',
  },
  {
    name: 'Dashboards',
    url: '/vaccine-history',
  },
];
